import { apiClient } from 'lib/apiClient';
import { CSVResult } from 'lib/types';

export function csvUploadFn(
  api: ReturnType<typeof apiClient>,
) {
  return function fn(fileType: string) {
    if (fileType !== 'text/csv' && fileType !== 'application/csv') {
      throw new Error('Invalid file type. Only CSV files are allowed.');
    }

    // Wrapper function to transform the API response into CSVResult[]
    return async (file: FormData, filename: string, folder: string): Promise<CSVResult[]> => {
      const result = await api.uploadCSVToDataBucket(file, filename, folder);
      return [result as CSVResult]; // Transform single result into array of CSVResult
    };
  };
}
